export default {
    import_account_label: 'Account',
    import_account_imported_on: 'Imported On',
    import_account_updated_on: 'Updated On',
    import_account_contacts: 'Contacts',
    import_account_alerts: 'Alerts',
    import_account_categories: 'Tags',
    import_account_behavior: 'Behavior',
    import_account_users: 'Users',
    import_account_drivers: 'Drivers',
    import_account_devices: 'Devices',
    import_account_geofences: 'Geofences',
    import_account_maintenance: 'Maintenance',
    import_account_exceptions: 'Exceptions',
    import_account_title: 'Migrations',
    import_account_import_account: 'Import Account',
    import_account_external_id: 'External Id',
    import_account_speed_override: 'Speed Override',
    import_account_source: 'Source',
    import_account_source_all: 'All',
    import_account_Done: 'Done',
    import_account_DoneWithErrors: 'Done with Errors',
    import_account_InProgress: 'In Progress',
    import_account_Pending: 'Pending',
    import_account_Failed: 'Failed',
    import_account_status: 'Status',
    import_account_internal_account_id: 'Internal Account Id',
    import_account_results: 'Results',
    import_account_results_updated_on: 'Last Sync On',
    import_account_assets: 'Assets'
};